define(function () {

    'use strict';


    return {

        MLEditor: {
            langs: ["EN", "FR"]
        },
        DSD_EDITOR_CODELISTS: [
            {
                "value": "HS|2012",
                "text": {
                    "EN": "HS",
                    "FR": "HS FR"
                },
                "subject": "item"
            },
            {
                "value": "CPC|2.1",
                "text": {
                    "EN": "CPC",
                    "FR": "CPC FR"
                },
                "subject": "item"
            },
            {
                "value": "CountrySTAT_Indicators",
                "text": {
                    "EN": "CountrySTAT_Indicators",
                    "FR": "CountrySTAT_Indicators FR"
                },
                "subject": "indicator"
            },
            {
                "value": "CountrySTAT_UM",
                "text": {
                    "EN": "CountrySTAT_UM",
                    "FR": "CountrySTAT_UM FR"
                },
                "subject": "um"
            },
            {
                "value": "UNECA_ISO3",
                "text": {
                    "EN": "UNECA_ISO3",
                    "FR": "UNECA_ISO3 FR"
                },
                "subject": "geo"
            },
            {
                "value": "UNECA_ClassificationOfActivities|2.0",
                "text": {
                    "EN": "UNECA_ClassificationOfActivities 2.0",
                    "FR": "UNECA_ClassificationOfActivities 2.0 FR"
                },
                "subject": "item"
            },
            {
                "value": "Flag",
                "text": {
                    "EN": "Flag",
                    "FR": "Flag FR"
                },
                "subject": "flag"
            },
            {
                "value": "UNECA_Gender",
                "text": {
                    "EN": "UNECA_Gender",
                    "FR": "UNECA_Gender FR"
                },
                "subject": "gender"
            },
            {
                "value": "UNECA_Energy",
                "text": {
                    "EN": "UNECA_Energy",
                    "FR": "UNECA_Energy"
                },
                "subject": "item"
            },
            {
                "value": "UNECA_UnitMeasure",
                "text": {
                    "EN": "UNECA_UnitMeasure UM",
                    "FR": "UNECA_UnitMeasure UM FR"
                },
                "subject": "um"
            }

        ]

    };

});


//////////////////
// WEBPACK FOOTER
// ./src/config/dsd-editor.js
// module id = 65
// module chunks = 0